import { useContext } from 'react'

import { EmailProfileContext } from '../../Email.contexts'

export function useEmailProfileContext() {
  return useContext(EmailProfileContext)
}
